module.exports = __webpack_public_path__ + "assets/emoticon-5star.36b1fa7e.svg";